export const cardStyles = {
  display: 'flex',
  height: '70%',
  width: '65%',
  marginInline: 'auto',
  justifyContent: 'center',
};

export const boxStyles = {
  display: 'flex',
  flexDirection: 'column',
};

export const typographyStyles = {
  marginTop: '1rem',
};

export const cardContentStyles = {
  display: 'flex',
  flexDirection: 'column',
  padding: '0 !important',
};

export const textFieldStyles = {
  width: '400px',
  marginTop: '2rem',
};

export const buttonStyles = {
  marginTop: '2rem',
  width: '400px',
  marginInline: 'auto',
};

export const typographyStyles3 = {
  marginTop: '3rem',
  textAlign: 'left',
};
